import { createFileRoute } from "@tanstack/react-router";
import { EditorStepId, isEditorStep } from "@/features/editor/types";

export const Route = createFileRoute("/editor/$projectId")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { step?: EditorStepId } => ({
    step: isEditorStep(search.step) ? search.step : undefined,
  }),
});
